/** Two-column generator shell — minmax keeps the left track from overflowing. */
export const LIP_GEN_GRID_CLASS =
  "grid w-full min-w-0 max-w-full grid-cols-1 max-xl:min-h-0 xl:h-full xl:min-h-0 xl:flex-1 xl:grid-cols-[minmax(0,390px)_minmax(0,1fr)] xl:items-stretch xl:overflow-hidden";

/** Left input column inside the 390px track. */
export const LIP_GEN_ASIDE_CLASS =
  "flex min-w-0 w-full max-w-full flex-col overflow-x-hidden max-xl:order-1 max-xl:min-h-0 xl:order-none xl:h-full xl:min-h-0 xl:overflow-hidden";

/** Scrollable form body; pr-3 leaves room for the xl scrollbar. */
export const LIP_GEN_ASIDE_BODY_CLASS =
  "lip-generator-scroll lip-gen-aside-body min-w-0 max-w-full pb-2 max-xl:overflow-x-hidden max-xl:overflow-visible xl:min-h-0 xl:flex-1 xl:overflow-y-auto xl:overflow-x-hidden xl:pr-3 xl:[-webkit-overflow-scrolling:touch]";

/** Generate / sign-in block pinned under the scroll area. */
export const LIP_GEN_ASIDE_ACTIONS_CLASS =
  "lip-gen-aside-actions shrink-0 min-w-0 max-w-full space-y-1.5 overflow-hidden border-ui-border pt-4 pr-3";

export const LIP_GEN_INPUT_TABS_CLASS =
  "lip-gen-input-tabs mt-2 min-w-0 max-w-full xl:[content-visibility:auto] xl:[contain-intrinsic-size:auto_12rem]";

/** Audio / record tab panels — reserve height to match the upload drop zone and limit CLS. */
export const LIP_GEN_AUDIO_INPUT_PANEL_CLASS =
  "mt-4 min-h-[11rem] [contain-intrinsic-size:auto_11rem]";

export const LIP_GEN_INPUT_TABS_GRID_CLASS =
  "grid min-w-0 max-w-full grid-cols-3 gap-0.5 rounded-lg bg-ui-surface-muted p-1 dark:bg-ui-elevated";

export const LIP_GEN_INPUT_TAB_BTN_CLASS =
  "min-w-0 max-w-full truncate rounded-lg px-1 py-2 text-xs font-bold leading-tight transition sm:px-1.5 sm:py-2.5 sm:text-sm";

export const LIP_GEN_ASIDE_TIPS_CLASS =
  "flex min-w-0 max-w-full flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-center text-xs text-ui-fg-secondary";

/** Right panel preview column — fills remaining viewport height on xl+. */
export const LIP_GEN_PREVIEW_PANE_CLASS =
  "lip-gen-preview-pane flex min-h-0 flex-1 flex-col xl:min-h-0 xl:overflow-hidden xl:[content-visibility:auto]";

/** Title block above demo video — fixed height, does not shrink. */
export const LIP_GEN_PREVIEW_HEADING_CLASS =
  "relative z-10 w-full shrink-0 text-center";

/**
 * Demo / result video stage.
 * Mobile: 16:9 with capped height. Desktop: flex-grow to fill right panel.
 */
export const LIP_GEN_PREVIEW_MEDIA_CLASS =
  "relative mt-4 flex min-h-0 w-full flex-1 overflow-hidden rounded-xl border border-ui-border bg-black max-xl:aspect-video max-xl:max-h-[min(50svh,440px)] xl:mt-5 xl:min-h-[10rem]";

/** AI Influencer: three portrait demos — mobile uses natural aspect ratio; xl fills remaining panel height. */
export const LIP_GEN_PREVIEW_MEDIA_TRIPLE_CLASS =
  "relative mt-4 w-full max-xl:shrink-0 overflow-hidden xl:mt-5 xl:min-h-0 xl:flex-1";

/** Inner column under right-panel toolbar — stretch to viewport on xl+. */
export const LIP_GEN_RIGHT_PANEL_COLUMN_CLASS =
  "flex w-full min-w-0 min-h-0 flex-1 flex-col";

/** Flex wrapper for preview/history transition slot. */
export const LIP_GEN_RIGHT_PANEL_BODY_CLASS = "flex min-h-0 flex-1 flex-col";
